import api from './baseApi';

export function getCurriculumVitaeByUserId(userId) {
  return api.get('/CurriculumVitae/' + userId);
}

export function createCurriculumVitae(curriculumVitae) {
  return api.post('/CurriculumVitae', curriculumVitae);
}

export function updateCurriculumVitae(curriculumVitae) {
  return api.put('/CurriculumVitae/' + curriculumVitae.id, curriculumVitae);
}

// Curriculum vitae experience
export function createCurriculumVitaeExperience(curriculumVitaeExperience) {
  return api.post('/CurriculumVitaeExperience', curriculumVitaeExperience);
}

export function updateCurriculumVitaeExperience(curriculumVitaeExperience) {
  return api.put('/CurriculumVitaeExperience/' + curriculumVitaeExperience.id, curriculumVitaeExperience);
}

export function deleteCurriculumVitaeExperience(curriculumVitaeExperienceId) {
  return api.delete('/CurriculumVitaeExperience/' + curriculumVitaeExperienceId);
}

// Curriculum vitae education
export function createCurriculumVitaeEducation(curriculumVitaeEducation) {
  return api.post('/CurriculumVitaeEducation', curriculumVitaeEducation);
}

export function updateCurriculumVitaeEducation(curriculumVitaeEducation) {
  return api.put('/CurriculumVitaeEducation/' + curriculumVitaeEducation.id, curriculumVitaeEducation);
}

export function deleteCurriculumVitaeEducation(curriculumVitaeEducationId) {
  return api.delete('/CurriculumVitaeEducation/' + curriculumVitaeEducationId);
}

// Curriculum vitae skill
export function createCurriculumVitaeSkill(curriculumVitaeSkill) {
  return api.post('/CurriculumVitaeSkill', curriculumVitaeSkill);
}

export function createMultipleCurriculumVitaeSkills(curriculumVitaeSkills) {
  return api.post('/CurriculumVitaeSkill/multiple', curriculumVitaeSkills)
}

export function updateCurriculumVitaeSkill(curriculumVitaeSkill) {
  return api.put('/CurriculumVitaeSkill/' + curriculumVitaeSkill.id, curriculumVitaeSkill);
}

export function deleteCurriculumVitaeSkill(curriculumVitaeSkillId) {
  return api.delete('/CurriculumVitaeSkill/' + curriculumVitaeSkillId);
}

export function getAllSkillSets() {
  return api.get('/CurriculumVitaeSkillSet');
}

// Curriculum vitae language
export function createCurriculumVitaeLanguage(curriculumVitaeLanguage) {
  return api.post('/CurriculumVitaeLanguage', curriculumVitaeLanguage);
}

export function updateCurriculumVitaeLanguage(curriculumVitaeLanguage) {
  return api.put('/CurriculumVitaeLanguage/' + curriculumVitaeLanguage.id, curriculumVitaeLanguage);
}

export function deleteCurriculumVitaeLanguage(curriculumVitaeLanguageId) {
  return api.delete('/CurriculumVitaeLanguage/' + curriculumVitaeLanguageId);
}

// Curriculum vitae certification
export function createCurriculumVitaeCertification(curriculumVitaeCertification) {
  return api.post('/CurriculumVitaeCertification', curriculumVitaeCertification);
}

export function updateCurriculumVitaeCertification(id, curriculumVitaeCertification) {
  return api.put(`/CurriculumVitaeCertification/${id}`, curriculumVitaeCertification);
}

export function deleteCurriculumVitaeCertification(curriculumVitaeCertificationId) {
  return api.delete('/CurriculumVitaeCertification/' + curriculumVitaeCertificationId);
}

// Curriculum vitae reference
export function createCurriculumVitaeReference(curriculumVitaeReference) {
  return api.post('/CurriculumVitaeReference', curriculumVitaeReference);
}

export function updateCurriculumVitaeReference(curriculumVitaeReference) {
  return api.put('/CurriculumVitaeReference/' + curriculumVitaeReference.id, curriculumVitaeReference);
}

export function deleteCurriculumVitaeReference(curriculumVitaeReferenceId) {
  return api.delete('/CurriculumVitaeReference/' + curriculumVitaeReferenceId);
}
